import React from 'react';
import { Dayjs } from 'dayjs';
import { Box } from '@mos-cat/ds';

import { getIsDateInInterval, getWeekDateByStartDate } from '../../../../../../helpers/date';
import { DAYS_IN_WEEK } from '../../../../../../constants/date';
import Day from './Day';

type Props = {
  startDate: Dayjs;
  dateFrom: Dayjs;
  dateTo: Dayjs;
};

export default function Week({ startDate, dateFrom, dateTo }: Props) {
  return (
    <Box as="tr">
      {Array.from({ length: DAYS_IN_WEEK }).map((_, day) => {
        const date = getWeekDateByStartDate(startDate, day);
        const isSelectedStart = date.isSame(dateFrom, 'date');
        const isSelectedEnd = date.isSame(dateTo, 'date');
        const isStartOrEndDate = isSelectedStart || isSelectedEnd;
        const isInInterval = !isStartOrEndDate && getIsDateInInterval({ dateFrom, dateTo, date });
        return (
          <Day
            key={date.format()}
            date={date}
            isSelectedStart={isSelectedStart}
            isSelectedEnd={isSelectedEnd}
            isInInterval={isInInterval}
          />
        );
      })}
    </Box>
  );
}
